module.exports = __webpack_public_path__ + "img/articlebg.7cb78ed0.png";